import { pricesResponseSelector } from '@/scopes/prices/components/selectors'
import { mapBulletIcon } from '@/scopes/prices/infrastructure/pricesByDuration/pricesResponseMapper'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { space, tokPx } from '@sunwebgroup/ui-components'
import { Icon, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_6')};
  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    flex-direction: row;
  }
`
const LegendItem = styled.div<{ $isBestValue: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_6')};
`

export function Legend() {
  const { highlightInfo } = usePricesSelector(pricesResponseSelector)

  if (!highlightInfo) {
    return null
  }
  return (
    <Wrapper>
      {highlightInfo.map(highlight => (
        <LegendItem key={highlight.code} $isBestValue={highlight.isBestValue ?? false}>
          <Icon glyph={mapBulletIcon(highlight.code)} size={16} />
          <Typography variant="body-xs-bold-flat">{highlight.description}</Typography>
        </LegendItem>
      ))}
    </Wrapper>
  )
}
